var constants = {
    contacts: {
        PHONE: "800-939-1980",
    },
    defaults: {
        CLICK: "",
        colors: {
            DARK: "#000",
            EMPTY: "transparent",
            hex: {
                DISABLED: "#efefef",
                LIGHT_GRAY: "#cbcbcb",
            },
            LIGHT: "#fff",
            rgb: {
                BLACK: "rgb(0,0,0)",
                WHITE: "rgb(255,255,255)",
            },
        },
        DASH: "-",
        EMAIL: "Type Email Address",
        LABEL_CREDIT_CARD: "Credit Card #",
        OPTION: -1,
        OPTION_VALIDATION: "",
        SELECT_ONE: "Select One",
        UNDERSCORE: "_",
        YOUR_LOGO_HERE: 999999,
        ZERO: 0,
    },
    flags: {
        FORCE_MIN_QTY: true,
        HAS_IMPRINT: 1,
        ITERATIONS: true,
    },
    form: {
        types: {
            BUTTON: "button",
            CHECK_BOX: "checkbox",
            HIDDEN: "hidden",
            SELECT_ONE: "select-one",
            TEXT: "text",
            TEXT_AREA: "textarea",
        },
    },
    graphql: {
        ENDPOINT: '/api/2026-07/graphql.json',
        STOREFRONT_ACCESS_TOKEN: '52675e3a8655feab55fc13379323343e',
    },
    headers: {
        alerts: {
            DEFAULT: "DiscountFavors.com Says: ",
            SEARCH: "Searching DiscountFavors.com...",
        },
    },
    item: {
        buttons: {
            ADD_TO_CART: "Add To Cart",
            /* BACK_SIDE_1: "Back:  Side 1", */
            /* BACK_SIDE_2: "Back:  Side 2", */
            /* BACK_STYLE_COLORS: "Back:  Qty &amp; Colors", */
            BACK_PRODUCT_DETAILS: "1. Product Details",
            DEFAULT: "&mdash;",
            NEXT_SHIPPING: "2:  Shipping",
            /* NEXT_SIDE_1: "Next:  Side 1", */
            /* NEXT_SIDE_2: "Next:  Side 2", */
            UPDATE_CART: "Update Cart",
            UPDATE_SHIPPING: "2:  Update Shipping",
            /* UPDATE_SIDE_2: "Next:  Update Side 2" */
        },
        defaults: {
            PRODUCTION_KEY: "N",
            QTY_PRICE: "0 pcs for $0.00",
            STYLE: "imprint",
        },
        FOR_MARKER: " pcs for ",
        forms: {
            DEFAULT: ".page-bigForm",
            SHIPPING: "#page-shippingForm",
        },
        panes: {
            ART_1: 0,
            ART_2: 1,
            SHIPPING: 2,
        },
        productionKeys: {
            BLANK: "B",
            NORMAL: "N",
            PREPRO: "N",
            RUSH_1: "R1",
            RUSH_2: "R2",
            SAMPLE: "N",
            STOCK: "N",
        },
        QTYS_PRICE_FIXED: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
        sellers: {
            DEFAULT: "Dfav",
            EBAY: "Ebay",
            ETSY: "Etsy",
        },
        side_two: {
            ADD: 4,
            COPY: 2,
            NONE: 1,
        },
        styles: {
            BLANK: "blank",
            IMPRINT: "imprint",
            PREPRO: "prepro",
            REORDER: "reorder",
            SAMPLE: "sample",
            STOCK: "stock",
        },
    },
    transits: {
        DAY_1: "1 Day",
        DAY_2: "2 Day",
        DAY_3: "3 Day",
        GROUND: "Ground",
    },
    labels: {
        NUMBER_EBAY: "Ebay Trans ID",
        NUMBER_ETSY: "Etsy Receipt #",
        steps: {
            left: {
                DEFAULT: "1 of 2:  Item Details.",
                ONE: "2 of 2:  Shipping.",
            },
        },
    },
    messages: {
        alerts: {
            BLANK: "",
            PAUSED: "This product is currently paused (either because it is out of stock or discontinued):  it cannot be purchased at this time.\n\nPlease try again later.",
            REMOVE_FROM_CART:
                "This action will remove %s (%s) from the cart and cannot be undone.\n\nIs this OK?",
        },
        html: {
            ADD_ON_NOTE: "<br /><br />Note:  ",
            CART_PRODUCT_SETUP_ERROR:
                'There was an error setting up the "%s" in the product editor.',
            CLEAR_SIDE_2: "Would you like to clear <strong>Side 2</strong>?",
            COPY_BILLING_STATE_CHANGE_MISMATCH:
                'You have set "Copy Billing" to "Yes".<br /><br />Since you are shipping to <strong>%s</strong>&mdash;and that state CANNOT be changed&mdash;the billing state has been reset to <strong>%s</strong>.',
            COPY_BILLING_STATE_MISMATCH:
                'Your billing state is <strong>%s</strong> but your order is shipping to <strong>%s</strong>.<br /><br />In order to use the "Copy Billing" feature, the billing state MUST be set to <strong>%s</strong>.',
            DATE_EXPIRED_CARD: "The date of the credit card has expired.",
            EBAY_ORDER:
                "Are you sure you want to place an <strong>Ebay</strong> order?<br /><br />Confirm (or change) your selection below...",
            EMAIL_INVALID: "You must enter a valid email address!",
            ERROR_CLUB:
                "There was an error submitting your email (or a duplicate was entered).<br /><br />Please try again later.",
            ERROR_DATE_CARD: "The credit card expiration date is invalid!",
            ERROR_COUPON_CODE_EXPIRED_OR_INVALID:
                "The code <strong>%s</strong> has expired or is invalid.",
            ERROR_COUPON_CODE_MISSING_OR_SHORT:
                "Please enter a valid coupon code.",
            ERROR_PO_BOX:
                '<span class="gbl-alert">We do NOT ship to P.O. boxes!</span><br /><br />The address field has been reset:  please enter a different address.',
            ERROR_PREFIX_CARD: "The credit card has an invalid number prefix!",
            FIX: "Please correct any form field(s) marked in yellow!",
            MISSING_CLIPART_WIDTH: "The clipart width is missing or null!",
            PROCESSOR:
                "Processing can take up to 10 seconds. If you encounter a problem, call 1-800-939-1980.",
            REMOVE_FROM_CART:
                "This action will remove <strong>%s (%s)</strong> from the cart and <em>cannot</em> be undone.<br /><br />Is this OK?",
            required: {
                SEARCH_TERM:
                    "A search term is required. Please type a term and try again.",
            },
            RESET_MASTER_STATE:
                'Your current "Ship To State" is <strong>%s</strong>.<br /><br />If you change the "Ship To State" now and add this product to your cart later, ALL the products in your cart will ship to <strong>%s</strong>.<br /><br /><span class="gbl-alert">THE DATES AND RATES WILL CHANGE!</span>',
            RESET_SPLITS:
                'Your total quantity is currently <strong>%s</strong>. If you chose a different total quantity now, the splits will reset.<br /><br />Is this "OK"?',
            STATE_THEN_ZIP: "You must select a <strong>State</strong> first!",
            SUCCESS_CLUB:
                "Thank you for joining the club. You'll begin receiving exclusive specials before anyone else shortly!",
            SUCCESS_CONTACT:
                "Thank you for contacting discountfavors.com. We will review your request or comment and respond appropriately to the occasion.",
            SUBSCRIBER_ERROR:
                "There was an error submitting your email (or a duplicate was entered).<br /><br />Please try again later.",
            SUBSCRIBER_SUCCESS:
                "Thank you for joining the club.<br /><br />You'll begin receiving our exclusive specials soon!<br /><br />Note:  we never share your email and you can unsubscribe anytime.",
            TAX_EXEMPT:
                "If you are a Florida tax exempt organization, follow these steps: <br /><br />1. Have your Florida sales tax exempt certificate in hand.<br />2. Make sure the certificate is signed.<br />3. Call 1-800-939-1980 to place your order with a sales representative.",
            TOOLTIP_SEARCH_CLIPART:
                "Looking for something specific?<br /><br />1. Think <i>clipart</i> words...<br />2. Type them here...<br />3. Press the Enter key.",
        },
        popup: {
            0: "",
            1: 'Note:  you can close this popup by making a selection or clicking the "Close" button.',
            2: 'Note:  you can close this popup by clicking the "Close" button.',
        },
    },
    routines: {
        TOP_NAV_BAR: 1,
        POPULAR_DESIGNS: 2,
        TOP_PRODUCTS: 4,
        FAVORS: 8,
        PRODUCTS: 16,
        CART_COUNT: 32,
        CART_ITEMS: 64,
        RECEIPT: 128,
        EMAIL: 256,
        RECEIPT_UNSET: 512,
        PAGE_FOUND: 1024,
    },
    statuses: Object.freeze({
        COMPLETED: 0,
        CANCELED: 1,
        NEW: 200,
        WORKING: 201,
        PENDING: 202,
        REJECTED: 203,
        PROOF_REVIEW: 300,
        PRINTING: 301,
        PRINT_REVIEW: 302,
        FLOOR: 400,
        VENDOR: 401,
        ORDER_REVIEW: 500,
        CANCEL: 501,
        CHANGES: 502,
        ON_HOLD: 503,
    }),
};
constants.suppressDefinedButNeverUsed = true;
